<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>公告管理</el-breadcrumb-item>
      <el-breadcrumb-item>公告列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-tabs v-model="tabIndex" @tab-click="handleClick">
        <el-tab-pane v-for="item in statusOptions" :key="item.id" :label="item.value"></el-tab-pane>
      </el-tabs>

      <el-row>
        <el-col :span="8">
          <el-input placeholder="请输入标题" v-model="queryInfo.query" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="getOrderList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4" v-if="canLook == 1">
          <el-button type="primary" @click="addClick">添加公告</el-button>
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>

        <el-table-column type="index"></el-table-column>
        <!-- <el-table-column label="编号" prop="id" width="80px"></el-table-column> -->
        <el-table-column label="标题" prop="title" width="160px"></el-table-column>
        <el-table-column label="状态" prop="status" width="120px">
          <!-- 自定义表头 -->
          <!-- <template slot="header" slot-scope="scope">
            <el-select v-model="queryInfo.status" placeholder="请选择" @change="filterSelect">
              <el-option v-for="item in statusOptions" :key="item.id" :label="item.value" :value="item.id"> </el-option>
            </el-select>
          </template> -->
          <!-- 全部-1 待支付0 待确认1 ,待发货2,已发货3 ,已完成4, 退款5 取消6 -->
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.status == '0'">待发布</el-tag>
            <el-tag class="daiqueren" v-if="scope.row.status == '1'">已发布</el-tag>
            <el-tag class="danger" v-if="scope.row.status == '2'">已隐藏</el-tag>
            <!-- <el-tag type="danger" v-else>未付款</el-tag> -->
          </template>
        </el-table-column>

        <el-table-column label="创建时间" prop="create_at" align="center" width="130px">
          <template slot-scope="scope">
            {{ scope.row.create_at | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="editNotice(scope.row.id)">编辑</el-button>
            <el-button size="mini" type="primary" v-if="tabIndex == 1 || tabIndex == 3" @click="sendNotice(scope.row.id)">发布</el-button>
            <el-button size="mini" type="danger" @click="deleteNotice(scope.row.id)">删除</el-button>
            <el-button size="mini" type="info" v-if="tabIndex == 2" @click="hiddenNotice(scope.row.id)">隐藏</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row v-if="canLook == 1">
        <el-button type="primary" plain @click="sendNews">批量发布</el-button>
        <el-button type="info" plain @click="hiddenNews">批量隐藏</el-button>
        <el-button type="success" plain @click="deleteNews">批量删除</el-button>
      </el-row>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  data () {
    return {
      tabIndex: 0,
      canLook: 1,
      queryInfo: {
        query: '',
        status: -1,
        pagenum: 1,
        pagesize: 10
      },
      statusValue: '全部',
      statusOptions: [
        { value: '全部', id: -1 },
        { value: '待发布', id: 0 },
        { value: '已发布', id: 1 },
        { value: '已隐藏', id: 2 },
      ],
      total: 0,
      orderlist: [],
    }
  },

  created () {
    this.getOrderList()
  },

  methods: {
    // 添加
    addClick () {
      this.$router.push('/noticeList/add')
    },
    // 编辑
    editNotice (id) {
      console.log(id);
      this.$router.push({ path: '/noticeList/add', query: { id: id } })
    },


    handleClick (tab, event) {
      console.log(tab.index);
      this.tabIndex = tab.index;
      this.queryInfo.status = tab.index - 1
      this.filterSelect();
    },

    filterSelect () {
      this.total = 0
      this.orderlist = []
      this.getOrderList()
    },

    // 多选选择的项
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },

    // 发布单个公告
    async sendNotice (id) {
      const confirmResult = await this.$confirm(
        '将发布公告， 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      //  type=1发布 2隐藏 3删除
      const { data: res } = await this.$http.post('admin/notice/sendNotice', {
        id: id,
        type: 1
      })
      if (res.code !== 200) {
        return this.$message.error('发布失败！')
      }
      this.$message.success('发布成功！')
      this.filterSelect()
    },

    // 隐藏单个公告
    async hiddenNotice (id) {

      const confirmResult = await this.$confirm(
        '将隐藏掉公告, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      //  type=1发布 2隐藏 3删除
      const { data: res } = await this.$http.post('admin/notice/sendNotice', {
        id: id,
        type: 2
      })
      if (res.code !== 200) {
        return this.$message.error('隐藏失败！')
      }
      this.$message.success('隐藏成功！')
      this.filterSelect()
    },

    // 单个删除
    async deleteNotice (id) {

      const confirmResult = await this.$confirm(
        '将删除的公告，无法找回, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      //  type=1发布 2隐藏 3删除
      const { data: res } = await this.$http.post('admin/notice/sendNotice', {
        id: id,
        type: 3
      })
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.$message.success('操作成功！')
      this.filterSelect()
    },

    // 批量发布公告
    async sendNews () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选！')
      }
      const confirmResult = await this.$confirm(
        '将发布所有已选中的公告， 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/notice/changeStatus', {
        data: this.multipleSelection,
        type: 1,
      })
      if (res.code !== 200) {
        return this.$message.error('发布失败！')
      }
      this.$message.success('发布成功！')
      this.filterSelect()
    },

    // 隐藏公告
    async hiddenNews () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选！')
      }
      const confirmResult = await this.$confirm(
        '将隐藏掉所有已选中的公告, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/notice/changeStatus', {
        data: this.multipleSelection,
        type: 2,
      })
      if (res.code !== 200) {
        return this.$message.error('隐藏失败！')
      }
      this.$message.success('批量隐藏成功！')
      this.filterSelect()
    },

    // 批量删除
    async deleteNews () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选！')
      }
      const confirmResult = await this.$confirm(
        '将删除已选中的公告，无法找回, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/notice/changeStatus', {
        data: this.multipleSelection,
        type: 3,
      })
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.$message.success('操作成功！')
      this.filterSelect()
    },


    async getOrderList () {
       if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
      const { data: res } = await this.$http.get('admin/notice/getList', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('获取列表失败！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
     
    },


    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },


  }
}
</script>

<style lang="less" scoped>
@import '../../plugins/timeline/timeline.css';
@import '../../plugins/timeline-item/timeline-item.css';

.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 30px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}
</style>
